var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',[_c('label',{staticClass:"mb-1 text-lg d-flex align-items-center"},[_vm._v(" Mô tả ")]),_c('b-input',{attrs:{"type":"text","placeholder":"Nhập mô tả..."},model:{value:(_vm.entry.description),callback:function ($$v) {_vm.$set(_vm.entry, "description", $$v)},expression:"entry.description"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }